import React from 'react';
import { useQuery, Loading, Error, SelectInput, required } from 'react-admin';

const TitleField = ({props}) =>{
 
    let titles =  [];
    var source = props && props.source? props.source : 'level'
    var label = props && props.label ? props.label : 'Title/Role'

    const { data, loading, error } = useQuery({ 
        type: 'getList',
        resource: 'usertitles',
        payload:  {
            pagination: { page: 1 , perPage: 20 },
            sort: { field: 'title', order: 'ASC' }
        }
    });
 
    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    titles = data;
    //console.log(data)
    return (
        <SelectInput source={source}    label={label} choices={titles} validate={required()} />
        )
}

export default TitleField